import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import {
  VolumeUpIcon,
  CollectionIcon,
  IdentificationIcon,
  UserGroupIcon,
  CalendarIcon,
  DocumentTextIcon,
  CurrencyDollarIcon,
  ClipboardCopyIcon,
  ClipboardListIcon,
  AnnotationIcon,
  BookOpenIcon,
} from "@heroicons/react/outline";
import SideFooter from "../../components/sidebar/SideFooter";
import { useAuth } from "../../context/AuthContext";
import SidebarWithHeader from "../../components/Layouts/SidebarWithHaeder";
import AppLogo from "../../components/AppLogo";
import { makeApiRequest, showApiErrorMessages } from "../../helpers";
import { showApologizeRequests } from "../../api/endpoints/tutors/requests";
import { ApiResponse } from "../../api/apiResponse";
import RequestsModel from "../../api/models/RequestsModel";
import { getTutorGlobal } from "../../api/endpoints/tutors/statistics";
import { useQuery } from "react-query";
import LearnDashUserModel from "../../api/models/LearnDashUserModel";
import CandidateModel from "../../api/models/CandidateModel";
import { getTutor } from "../../api/endpoints/tutors/tutors";

function TutorDashboardPage() {
  const [langModal, setLangModal] = useState(false);
  const userContext = useAuth();
  const [requestsReceived, setRequestsReceived] = useState<RequestsModel[]>([]);
  const [scheduleRequests, setScheduleRequests] = useState<number>(0);
  const showReceivedCancelRequests = async () => {
    await makeApiRequest(
      () =>
        showApologizeRequests({
          filters: {
            sender_type: "Student",
            status: "pending",
          },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] =
            RequestsModel.fromApiResponsePending(data, "receiver");
          setRequestsReceived(requestsList);
        }
      }
    );
  };
  const { data: learnDashUser } = useQuery("learnDashUser", getTutor, {
    staleTime: Infinity,
    select: (response) => {
      let learnDashUser: LearnDashUserModel | null = null;
      if (response.isSuccess) {
        const candidate: CandidateModel = CandidateModel.fromApiResponse(
          response.data
        );
        learnDashUser = candidate.learnDashUser;
      } else {
        showApiErrorMessages(response);
      }
      return learnDashUser;
    },
  });

  const getStatistics = async () => {
    try {
      const res = await getTutorGlobal();
      if (res.isSuccess) {
        const { schedule_requests } = res.data;
        setScheduleRequests(schedule_requests);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const { t, i18n } = useTranslation("", {
    keyPrefix: "page.tutor.dashboard.nav",
  });
  useEffect(() => {
    showReceivedCancelRequests();
    getStatistics();
  }, []);
  const navigation: any = [
    {
      name: t("homePage"),
      href: "/tutor/dashboard/room",
      icon: VolumeUpIcon,
      separate: "bottom",
    },
    {
      name: t("weeklySchedule"),
      href: "/tutor/dashboard/weekly-schedule",
      icon: CalendarIcon,
    },
    {
      name: t("readingSessions"),
      href: "/tutor/dashboard/sessions",
      icon: CollectionIcon,
      separate: "bottom",
    },
    {
      name: t("readers"),
      href: "/tutor/dashboard/readers",
      icon: UserGroupIcon,
      separate: "bottom",
    },
    {
      name: t(`requests`),
      icon: DocumentTextIcon,
      separate: "bottom",
      counter: scheduleRequests,
      children: [
        {
          name: t(`apologizeSession`),
          href: "/tutor/dashboard/requests",
          counter: requestsReceived.length,
        },
        {
          name: t(`changeAppointment`),
          href: "/tutor/dashboard/appointments-requests/false",
        },
        {
          name: t(`newStudents`),
          href: "/tutor/dashboard/new-students",
        },
      ],
    },
    {
      name: t("selfLearningPlatform"),
      href: "/tutor/dashboard/room",
      icon: ClipboardListIcon,
      learnDash: true,
      learnDashUser: learnDashUser,
      separate: "bottom",
    },
    {
      name: t("myFinancialDues"),
      href: "/tutor/dashboard/financial-dues",
      icon: CurrencyDollarIcon,
    },

    {
      name: t("personalData"),
      href: "/tutor/dashboard/personal-info",
      icon: IdentificationIcon,
    },
    {
      name: t(`politics`),
      href:
        i18n.language === "ar"
          ? "https://www.sanadquran.com/policies/"
          : "https://www.sanadquran.com/policies/",
      icon: AnnotationIcon,
      isBrowserLink: true,
    },
    {
      name: t(`tutorial`),
      href:
        i18n.language === "ar"
          ? "https://www.sanadquran.com/ar/tutorial-video-tutor/"
          : "https://www.sanadquran.com/en/tutorial-video-tutor/",
      icon: BookOpenIcon,
      isBrowserLink: true,
      separate: "bottom",
    },
  ];

  const userImg = userContext?.currentUser?.profile_picture_url;

  return (
    <div className="">
      <div className="">
        <SidebarWithHeader
          langModal={langModal}
          setLangModal={setLangModal}
          img={userImg}
          navigation={navigation}
          sideHeader={
            <div className="w-full px-2 pt-5 pb-4">
              <AppLogo />
            </div>
          }
          sideFooter={
            <SideFooter langModal={langModal} setLangModal={setLangModal} />
          }
        ></SidebarWithHeader>
      </div>
    </div>
  );
}
export default TutorDashboardPage;
